import { Component } from 'react';
import filter from 'transmute/filter';
import reduce from 'transmute/reduce';
import get from 'transmute/get';
import indexBy from 'transmute/indexBy';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import PropTypes from 'prop-types';
import DnDSearchResultsItem from 'crm_components/dialog/propertyListEditor/DnDSearchResultsItem';
import { COLUMN_SETTINGS, FAVORITE_PROPERTIES, CREATOR_PROPERTIES, DEAL_STAGE_PROPERTIES, TICKET_STAGE_PROPERTIES } from 'customer-data-objects/property/PropertyListTypes';
import DefaultObjectProperties from 'customer-data-objects/constants/DefaultObjectProperties';
import { AutoSizer, List as VirtualizedList } from 'react-virtualized';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const MIN_LIST_HEIGHT = 276;
class SearchResultsCategories extends Component {
  constructor(...args) {
    super(...args);
    this.isDisabled = ({
      value
    }, selected) => {
      const {
        use,
        type
      } = this.props;
      const previewProperties = selected.get(value);
      return use === CREATOR_PROPERTIES && DefaultObjectProperties.getIn([type, value, 'disabled', 'removal']) || previewProperties && (previewProperties.disabled || previewProperties.readOnly);
    };
    this.getFilteredProperties = () => {
      const {
        search
      } = this.props;
      const match = ({
        text
      }) => text != null ? text.toLowerCase().indexOf((search || '').toLowerCase()) !== -1 : true;
      return reduce([], (allResults, currentCategory) => {
        if (currentCategory.options.length === 0) {
          return allResults;
        }
        const filteredProperties = filter(match, currentCategory.options);
        if (filteredProperties.length !== 0) {
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
          allResults.push(currentCategory, ...filteredProperties);
        }
        return allResults;
      },
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
      this.props.optionGroups);
    };
    this.getSelectedPropertiesMap = () => {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '<T extends object | Iterable<any... Remove this comment to see the full error message
      return indexBy(get('value'), this.props.selectedOptions);
    };
    this.renderCategory = (row, category) => {
      const {
        position,
        top,
        left,
        height,
        width
      } = row.style;
      return /*#__PURE__*/_jsx("div", {
        style: {
          position,
          top,
          left,
          height,
          width
        },
        children: /*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          marginBlockEnd: "200",
          marginBlockStart: "400",
          children: category.text || category.value
        })
      }, category.value);
    };
    this.renderCategoryProperty = (row, option) => {
      const {
        onAddOption,
        onRemoveOption,
        onReset,
        onSave,
        type
      } = this.props;
      const selected = this.getSelectedPropertiesMap();
      const disabled = this.isDisabled(option, selected);
      const {
        position,
        top,
        left,
        height,
        width
      } = row.style;
      return /*#__PURE__*/_jsx("div", {
        style: {
          position,
          top,
          left,
          height,
          width
        },
        children: /*#__PURE__*/_jsx(View, {
          as: "div",
          paddingInlineStart: "400",
          paddingInlineEnd: "300",
          children: /*#__PURE__*/_jsx(DnDSearchResultsItem, {
            disabled: disabled,
            index: -1,
            objectType: type,
            onDrop: onSave,
            onMove: onReset,
            onReset: onReset,
            onSelect: onAddOption,
            onUnselect: onRemoveOption,
            property: option,
            selected: selected.get(option.value),
            tabIndex: 0
          })
        })
      }, `${option.groupName}:${option.value}`);
    };
    this.renderNoResults = () => {
      return /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "crm_components.GenericModal.noProperty"
        })
      });
    };
    this.renderRow = (rows, row) => {
      const entry = rows[row.index];
      if (entry.options) {
        return this.renderCategory(row, entry);
      }
      return this.renderCategoryProperty(row, entry);
    };
    this.renderList = filteredProperties => {
      /* eslint-disable-next-line react/display-name */
      return dimensions => {
        // In Unit Tests `height` and `width` are 0 which causes this to render nothing.
        const height = dimensions.height === 0 ? MIN_LIST_HEIGHT : dimensions.height;
        const width = dimensions.width === 0 ? 400 : dimensions.width;
        return /*#__PURE__*/_jsx(VirtualizedList, {
          height: height,
          rowCount: filteredProperties.length,
          rowHeight: 40
          /* eslint-disable-next-line react/no-this-in-sfc */,
          rowRenderer: row => this.renderRow(filteredProperties, row),
          width: width
          /* eslint-disable-next-line react/no-this-in-sfc */
        }, this.props.search);
      };
    };
  }
  render() {
    const filteredProperties = this.getFilteredProperties();
    if (filteredProperties.length === 0) {
      return this.renderNoResults();
    }
    return /*#__PURE__*/_jsx(Flex, {
      flexGrow: 1,
      minBlockSize: `${MIN_LIST_HEIGHT}px`,
      children: /*#__PURE__*/_jsx(AutoSizer, {
        children: this.renderList(filteredProperties)
      })
    });
  }
}
SearchResultsCategories.displayName = 'SearchResultsCategories';
SearchResultsCategories.propTypes = {
  search: PropTypes.string,
  onAddOption: PropTypes.func.isRequired,
  onRemoveOption: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  optionGroups: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
  use: PropTypes.oneOf([COLUMN_SETTINGS, FAVORITE_PROPERTIES, CREATOR_PROPERTIES, DEAL_STAGE_PROPERTIES, TICKET_STAGE_PROPERTIES]).isRequired
};
export default SearchResultsCategories;